export enum STATUS {
   NONE = 0,
   ACTIVE,
   NOTACTIVE,
   SENDERROR,
   IDERROR,
   LOADERROR,
   SUCCESS,
   SUCCESSREDIRECT,
   LOGINREDIRECT
}
